import { __ONLY_WRITE_STATE_FROM_ACTIONS as writeState } from "@/__main__/app-state.mjs";
import { IS_APP, IS_NODE, isPersistent } from "@/__main__/constants.mjs";
import { readData } from "@/__main__/get-data.mjs";
import blitzMessage, { EVENTS } from "@/__main__/ipc-core.mjs";
import type { AuthTokenObject } from "@/feature-auth/models/token-model.mjs";

class AuthTokenHandler {
  memoizedTokenObject: AuthTokenObject | null | undefined;

  async getToken(): Promise<string | null> {
    return (await this.#getTokenObject())?.authToken ?? null;
  }

  async getTokenExpiry(): Promise<Date | null> {
    return (await this.#getTokenObject())?.authTokenExpiry ?? null;
  }

  async unsetToken() {
    await this.setToken(undefined);
  }

  async setToken(token: AuthTokenObject | null | undefined) {
    this.memoizedTokenObject = token;

    if (!IS_APP) {
      if (token) {
        if (typeof token.authTokenExpiry === "number")
          token.authTokenExpiry = new Date(token.authTokenExpiry);

        token[isPersistent] = token.authTokenExpiry.getTime();

        writeState.auth.token = token;
      } else {
        delete writeState.auth.token;
      }
    } else {
      await blitzMessage(EVENTS.SAVE_TOKEN, token);
    }
  }

  async #getTokenObject(): Promise<AuthTokenObject> {
    if (this.memoizedTokenObject !== undefined) return this.memoizedTokenObject;

    let tokenObject: AuthTokenObject | null = null;

    if (!IS_APP && !IS_NODE) {
      tokenObject = await readData(["auth", "token"]);
    } else {
      tokenObject = (await blitzMessage(EVENTS.LOAD_TOKEN)) as AuthTokenObject;
    }

    if (typeof tokenObject?.authTokenExpiry === "number")
      tokenObject.authTokenExpiry = new Date(tokenObject.authTokenExpiry);

    this.memoizedTokenObject = tokenObject;

    return tokenObject;
  }
}

export const authTokenHandler = new AuthTokenHandler();
